<template>
  <component :is="currentComponent"></component>
</template>

<script>
import PRPMicroneedlingFacialContentEn from './PRPMicroneedlingFacialContent/PRPMicroneedlingFacialContentEn.vue';
import PRPMicroneedlingFacialContentPtBR from './PRPMicroneedlingFacialContent/PRPMicroneedlingFacialContentPtBR.vue';
import PRPMicroneedlingFacialContentEs from './PRPMicroneedlingFacialContent/PRPMicroneedlingFacialContentEs.vue';
import { LANGUAGES } from '@/common/constants';

export default {
  props: {
    language: {
      type: String,
      default: LANGUAGES.EN
    }
  },
  computed: {
    currentComponent() {
      if (this.language === LANGUAGES.PT_BR) {
        return PRPMicroneedlingFacialContentPtBR;
      }
      if (this.language === LANGUAGES.ES) {
        return PRPMicroneedlingFacialContentEs;
      }
      return PRPMicroneedlingFacialContentEn;
    }
  }
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
